import React, { ReactNode } from 'react';
import { Table, Tooltip } from 'antd';

import blueCheck from '../assets/icon/blueCheck.svg';
import greyCheck from '../assets/icon/greyCheck.svg';

const FULL = 'full';
const PARTIAL = 'all';
const NONE = 'none';
const renderAvailability = (value) => {
  switch (value) {
    case FULL:
      return (
        <img className='mx-auto' src={blueCheck} alt='checkmark' width={24} />
      );
    case PARTIAL:
      return (
        <img className='mx-auto' src={greyCheck} alt='checkmark' width={24} />
      );
    case NONE:
      return (
        <div className='blank-placeholder' role='img' aria-label='dash icon' />
      );
    default:
      return <p className='mx-auto text-base'>{value}</p>;
  }
};

export default function FeatureTable() {
  const columns = [
    {
      title: 'Included When Signing Up',
      dataIndex: 'name',
      render: (feature, record) =>
        record?.description ? (
          <Tooltip
            placement='right'
            title={record.description}
            trigger='hover'
            color='#DCE1E5'
            overlayClassName='grey-800 gMedium'
            overlayInnerStyle={{ color: 'inherit' }}
            className='cp txt-underline'
          >
            {feature}
          </Tooltip>
        ) : (
          <div className=' txt-underline'>{feature}</div>
        ),
    },
    {
      title: 'Other Platforms',
      dataIndex: 'free',
      className: ' grey-bg txt-center',
      render: renderAvailability,
    },
    {
      title: 'swimbooker',
      dataIndex: 'plus',
      className: 'txt-center',
      render: renderAvailability,
    },
  ];

  const features = [
    {
      name: 'Booking Management',
      free: PARTIAL,
      plus: FULL,
      description:
        'Complete bookings management allowing you to take online and offline bookings',
    },
    {
      name: 'No Fees For Anglers',
      free: NONE,
      plus: FULL,
      description:
        'swimbooker is completely free to use for anglers; no additional booking fees',
    },
    {
      name: 'E-Commerce',
      free: NONE,
      plus: FULL,
      description:
        ' Increase revenue per booking by selling additional products and services',
    },
    {
      name: 'Catch Report Management System',
      free: NONE,
      plus: FULL,
      description:
        ' A centralised tool to manage all catch reports at your venues. Share directly to your socials from the fishery manager!',
    },
    {
      name: 'Lake Exclusives + Reminder Emails',
      free: NONE,
      plus: FULL,
      description:
        ' Easily take lake exclusive booking with deposit/balance system and automated reminder emails to chase payment',
    },
    {
      name: 'Advanced Member Management',
      free: NONE,
      plus: FULL,
      description:
        'Manage renewals, member details or sell season tickets. Keep detailed member files and ensure all details are recorded',
    },
    {
      name: 'Marketing Promotion System',
      free: NONE,
      plus: FULL,
      description:
        'Take advantage of our swimbooker+ ecosystem allowing you to offer special deals to our users to drive more business',
    },
    {
      name: 'Fishery Gate Access System',
      free: NONE,
      plus: FULL,
      description:
        ' Customise how and when you deliver access to your venue via email and push notification',
    },
    {
      name: 'SB Hosted Media Pack',
      free: NONE,
      plus: FULL,
      description:
        'Take advantage of our talented media team to capture your venue in the best light possible',
    },
  ];

  return (
    <Table
      className='plan-features-table mx-auto max-w-md  mg-bottom-50 pd-bottom-20'
      columns={columns}
      dataSource={features}
      pagination={false}
    />
  );
}
